var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWind = function SvgWind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15C10.2648 15.7148 11.068 16.25 11.875 16.25C12.3723 16.25 12.8492 16.0525 13.2008 15.7008C13.5525 15.3492 13.75 14.8723 13.75 14.375C13.75 13.8777 13.5525 13.4008 13.2008 13.0492C12.8492 12.6975 12.3723 12.5 11.875 12.5H3.125",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5C7.76484 4.28516 8.56797 3.75 9.375 3.75C9.87228 3.75 10.3492 3.94754 10.7008 4.29917C11.0525 4.65081 11.25 5.12772 11.25 5.625C11.25 6.12228 11.0525 6.59919 10.7008 6.95083C10.3492 7.30246 9.87228 7.5 9.375 7.5H1.875",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 7.5C14.6398 6.78516 15.443 6.25 16.25 6.25C16.7473 6.25 17.2242 6.44754 17.5758 6.79917C17.9275 7.15081 18.125 7.62772 18.125 8.125C18.125 8.62228 17.9275 9.09919 17.5758 9.45083C17.2242 9.80246 16.7473 10 16.25 10H2.5",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgWind;